(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda', [
        'uwAgenda.help',
        'uwAgenda.global'
    ]);

    module.constant('AgendaList', {
        "UnconfirmedAppointments": 1,
        "StateList": 2,
        "DeletedAppointments": 3,
        "UrgentAppointments": 4
    });
    module.constant('AppointmentState', {
        "None": { name: "None", value: 0, color: "grey-salt", thumb: "fa-thumbs-o-up" },
        "Present": { name: "Present", value: 1, color: "green-jungle", thumb: "fa-thumbs-o-up" },
        "Urgent": { name: "Urgent", value: 2, color: "red-soft", thumb: "fa-exclamation" },
        "FollowUp": { name: "FollowUp", value: 3, color: "blue-soft", thumb: "fa-thumbs-o-up fa-rotate-270" },
        "NoShow": { name: "NoShow", value: 4, color: "red-soft", thumb: "fa-thumbs-o-down" },
        "Finished": { name: "Finished", value: 5, color: "yellow", thumb: "fa-thumbs-o-up" }
    });
    module.constant('DayTaskBroadcast', {
        'ShowReaction': 'daytasks:showreaction',
        'HideReaction': 'daytasks:hidereaction'
    });
    module.constant('AgendaBroadcast', {
        "Refresh": "agenda-time:paste",
        "AbortCutCopy": "agenda-time:abort:cut:copy",
        "StatusUpdated": "agenda-time:status-update",
        "PaymentStatusChanged": "agenda-time:payment-update",
        "BlockUnblock": "agenda-block:unblock",
        "AddContactInfo": "agenda-appointment:contact-info:add",
        "AddAdditionalInfo": "agenda-appointment:add-info:add",
        "AppointmentConfirmed": "agenda-appointment:confirmed"
    });
    module.constant('AgendaFilterBroadcast', {
        "AgendaLabelRefresh": "agendalabel:filterRefresh",
        "AgendaLabelCalculate": "agendalabel:filterCalculate",
        "AgendaLabelClear": "agendalabel:filterClear",
        "AppointmentTypeRefresh": "appointmenttype:filterRefresh",
        "AppointmentTypeCalculate": "appointmenttype:filterCalculate",
        "AppointmentTypeClear": "appointmenttype:filterClear",
        "AppointmentStateRefresh": "appointmentstate:filterRefresh",
        "AppointmentStateClear": "appointmentstate:filterClear",
        "WeekdayRefresh": "weekday:filterRefresh",
        "WeekdayCalculate": "weekday:filterCalculate",
        "WeekdayClear": "weekday:filterClear",
        "SharedAgendaRefresh": "sharedagenda:filterRefresh",
        "ListRefresh": "ffe:listrefresh"
    });

    module.constant('RecurrenceWeekOfMonth', {
        "First": { name: "recurrence_first_week_of_month", value: 1 },
        "Second": { name: "recurrence_second_week_of_month", value: 2 },
        "Third": { name: "recurrence_third_week_of_month", value: 3 },
        "Fourth": { name: "recurrence_fourth_week_of_month", value: 4 },
        "Last": { name: "recurrence_last_week_of_month", value: 5 }
    });
    module.constant('RecurrenceDuration', {
        "NoEnd": "0",
        "EndAfterXAppointments": "1",
        "EndOnDate": "2"
    });
    module.constant('RecurrenceUpdateMethod', {
        "Selected": { name: "Selected", value: 0 },
        "Future": { name: "Future", value: 1 }
    });
    module.constant('FastBlock', {
        "OneHour": { name: "one_hour", value: 1 },
        "TwoHours": { name: "two_hours", value: 2 },
        "RestOfDay": { name: "rest_of_day", value: 3 }
    });

    var getAgendaDayState = function(url, HelpCategoryEnum) {
        return {
            url: url, 
            templateUrl: '/app/agenda/templates/agenda-overview-per-day.template.html', 
            controller: 'AgendaOverviewController',
            controllerAs: 'vm',
            params: {
                today: false,
                isDayView: true,
                helpCategory: HelpCategoryEnum.AgendaDay
            },
            resolve: {
                today: ['$stateParams', 'DateService', today],
    
                deps: ['$ocLazyLoad', function ($ocLazyLoad) {                        
                    return $ocLazyLoad.load({
                        name: 'uwAgenda Agenda Day',
                        insertBefore: '#ng_load_plugins_before',
                        files: [
                            '/assets/lib/lazy-loaded/todo-2.min.css'
                        ]
                    });
                }]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'per_day' | translate}}"
            }        
        }
    };

    // state configuration
    module.config(['$stateProvider', 'HelpCategoryEnum', function AgendaConfigFn($stateProvider, HelpCategoryEnum) {

        $stateProvider
            .state('Home.Agenda_Day', getAgendaDayState('Agenda/Day/:agendaOwnerId', HelpCategoryEnum))
            .state('Home.Agenda_Day_Phone', getAgendaDayState('Agenda/Day/:agendaOwnerId/Phone/:phoneNumber', HelpCategoryEnum))
            .state('Home.Agenda_Week', {
                url: 'Agenda/Week',
                templateUrl: '/app/agenda/templates/agenda-overview-per-week.template.html',
                controller: 'AgendaOverviewController',
                controllerAs: 'vm',
                params: {
                    isDayView: false,
                    helpCategory: HelpCategoryEnum.AgendaWeek
                },
                resolve: {
                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda Agenda Week',
                            insertBefore: '#ng_load_plugins_before',
                            files: [
                                '/assets/lib/lazy-loaded/todo-2.min.css'
                            ]
                        });
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'per_week' | translate}}"
                }
            })
            .state('Home.Agenda_Appointment', {
                url: 'Appointment',
                templateUrl: '/app/agenda/templates/agenda-appointment-details.template.html',
                controller: 'AgendaAppointmentDetailController',
                controllerAs: 'vm',
                params: {                    
                    helpCategory: HelpCategoryEnum.AgendaGeneral
                },
                resolve: {
                    PreviousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name,
                            params: angular.copy($state.params),
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    labels: ['AgendaService', 'DateService', 'AppointmentDetailService', function (AgendaService, DateService, AppointmentDetailService) {                        
                        return AgendaService.onlyFreeAgendaItems(AppointmentDetailService.data.agenda.id, DateService.data.date).then(function (result) {
                            // give data to service -> resolve just for view
                            AppointmentDetailService.data.labels = result;
                            return result;
                        });
                    }],
                    types: ['AppointmentTypeService', 'AppointmentDetailService', function (AppointmentTypeService, AppointmentDetailService) {
                        return AppointmentTypeService.list(AppointmentDetailService.data.agenda.id).then(function (result) {
                            // give data to service -> resolve just for view
                            AppointmentDetailService.data.types = result;
                            return result;
                        });
                    }],
                    additionalinfotypes: ['UserService', 'AppointmentDetailService', function (UserService, AppointmentDetailService) {
                        return UserService.additionalinfos(AppointmentDetailService.data.agenda.owner.id, AppointmentDetailService.data.agenda.id);
                    }],
                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda New Appointment',
                            insertBefore: '#ng_load_plugins_before',
                            files: [
                                '/assets/lib/lazy-loaded/todo-2.min.css'
                            ]
                        });
                    }]                   
                },                
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'new_appointment' | translate}}"
                }
            })
            .state('Home.FirstFreeAppointments', {
                url: 'Agenda/FirstFreeAppointments',
                templateUrl: '/app/agenda/templates/agenda-first-free-appointments.template.html',
                controller: 'AgendaFirstFreeAppointmentController',
                controllerAs: 'vm',
                params: {
                    today: false,
                    helpCategory: HelpCategoryEnum.FirstFreeAppointments
                },
                resolve: {
                    today: ['$stateParams', 'DateService', today],

                    agendaLabels: ['AgendaLabelService', 'SharedAgendaService', function (AgendaLabelService, SharedAgendaService) {
                        // get agenda labels for all shared agendas of the current user
                        var agendaIds = [];
                        for (var i = 0; i < SharedAgendaService.data.agendas.length; i++) {
                            var agenda = SharedAgendaService.data.agendas[i];
                            if (agenda.isAgendaAccessibleToCurrentUser) {
                                agendaIds.push(agenda.id);
                            }
                        }
                        return AgendaLabelService.getByAgendas(agendaIds, true, true);
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{::'first_free_appointments' | translate}}"
                }
            })
             .state('Home.AgendaLists', {
                 url: 'Agenda/Lists',
                 templateUrl: '/app/agenda/templates/agenda-lists.template.html',
                 resolve: {
                     deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                         return $ocLazyLoad.load({
                             name: 'uwAgenda Agendalists',
                             insertBefore: '#ng_load_plugins_before',
                             files: [
                                 '/assets/lib/lazy-loaded/profile.css',
                                 '/assets/lib/lazy-loaded/todo-2.min.css',
                                 '/assets/lib/lazy-loaded/bootstrap-timepicker.min.css',

                                 '/assets/lib/lazy-loaded/todo-2.min.js',
                                 '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                                 '/assets/lib/lazy-loaded/bootstrap-timepicker.min.js',

                                 '/assets/lib/lazy-loaded/profile.min.js'
                             ]
                         });
                     }]
                 },
                 data: {
                     requiresLogin: true
                 },
                 ncyBreadcrumb: {
                     label: "{{'agenda_lists' | translate}}"
                 }
             })
        .state('Home.AgendaLists.Unconfirmed', {
            url: '/Unconfirmed',
            templateUrl: '/app/agenda/templates/agenda-lists-unconfirmed.template.html',
            controller: 'AgendaListsUnconfirmedController',
            controllerAs: 'vm',
            params: {
                today: false,
                helpCategory: HelpCategoryEnum.AppointmentListNew
            },
            resolve: {
                today: ['$stateParams', 'DateService', today]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'agendalist_UnconfirmedAppointments' | translate}}"
            }
        })
        .state('Home.AgendaLists.States', {
            url: '/States',
            templateUrl: '/app/agenda/templates/agenda-lists-states.template.html',
            controller: 'AgendaListsStatesController',
            controllerAs: 'vm',
            params: {
                today: false,
                helpCategory: HelpCategoryEnum.AppointmentListState
            },
            resolve: {
                today: ['$stateParams', 'DateService', today]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'agendalist_StateList' | translate}}"
            }
        })
        .state('Home.AgendaLists.Deleted', {
            url: '/Deleted',
            templateUrl: '/app/agenda/templates/agenda-lists-deleted.template.html',
            controller: 'AgendaListsDeletedController',
            controllerAs: 'vm',
            params: {
                today: false,
                helpCategory: HelpCategoryEnum.AppointmentListDeleted
            },
            resolve: {
                today: ['$stateParams', 'DateService', today]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'agendalist_DeletedAppointments' | translate}}"
            }
        })
        .state('Home.AgendaLists.Urgent', {
            url: '/Urgent',
            templateUrl: '/app/agenda/templates/agenda-lists-urgent.template.html',
            controller: 'AgendaListsUrgentController',
            controllerAs: 'vm',
            params: {
                today: false,
                helpCategory: HelpCategoryEnum.AppointmentListUrgent
            },
            resolve: {
                today: ['$stateParams', 'DateService', today]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'agendalist_UrgentAppointments' | translate}}"
            }
        })
        ;
    }]);

    // select today in calendar
    function today($stateParams, DateService) {
        // go to "TODAY" if param is set
        if ($stateParams.today && $stateParams.today === true) {
            // reset parameter
            $stateParams.today = false;
            return DateService.today();
        } //if
    } // today


})();